import { Col, Row } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdOutlineFreeCancellation,
  MdOutlineShareLocation,
} from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const BrokerageMandate = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const lastNamePath = "project.terminationRequest.brokerageMandate.lastName";
  const lastNameField = bindField(lastNamePath, {
    label: SUBSCRIPTION.FORM.LAST_NAME.LABEL,
    required: isFieldRequired(lastNamePath),
    disabled: true,
    onBlur: () => setPercent(initialValues),
  });

  const firstNamePath = "project.terminationRequest.brokerageMandate.firstName";
  const firstNameField = bindField(firstNamePath, {
    label: SUBSCRIPTION.FORM.FIRST_NAME.LABEL,
    required: isFieldRequired(firstNamePath),
    disabled: true,
    onBlur: () => setPercent(initialValues),
  });

  const currentCompanyPath =
    "project.terminationRequest.brokerageMandate.currentCompany";
  const currentCompanyField = bindField(currentCompanyPath, {
    label: SUBSCRIPTION.FORM.CURRENT_COMPANY.LABEL,
    required: isFieldRequired(currentCompanyPath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    get(initialValues, "project.ria", false) && (
      <div
        className="subscription-form--wrapper"
        id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.BROKERAGE_MANDATE}-section`}
      >
        <Form
          type="vertical"
          title={
            SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.BROKERAGE_MANDATE.TITLE
          }
          subtitle={
            SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.BROKERAGE_MANDATE.SUBTITLE
          }
        >
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <FormField
                path={lastNameField.path}
                label={lastNameField.label}
                required={lastNameField.required}
                disabled={lastNameField.disabled}
              >
                {(field) => (
                  <Input
                    placeholder={SUBSCRIPTION.FORM.LAST_NAME.PLACEHOLDER}
                    label={lastNameField.label}
                    icon={<MdOutlineFreeCancellation size={16} />}
                    defaultValue={lastNameField.defaultValue}
                    {...field}
                    onChange={lastNameField.onChange}
                    onBlur={lastNameField.onBlur}
                  />
                )}
              </FormField>
            </Col>
            <Col lg={24} xs={24}>
              <FormField
                path={firstNameField.path}
                label={firstNameField.label}
                required={firstNameField.required}
                disabled={firstNameField.disabled}
              >
                {(field) => (
                  <Input
                    placeholder={SUBSCRIPTION.FORM.FIRST_NAME.PLACEHOLDER}
                    label={firstNameField.label}
                    icon={<MdOutlineFreeCancellation size={16} />}
                    defaultValue={firstNameField.defaultValue}
                    {...field}
                    onChange={firstNameField.onChange}
                    onBlur={firstNameField.onBlur}
                  />
                )}
              </FormField>
            </Col>
            <Col lg={24} xs={24}>
              <FormField
                path={currentCompanyField.path}
                label={currentCompanyField.label}
                required={currentCompanyField.required}
                disabled={currentCompanyField.disabled}
              >
                {(field) => (
                  <Input
                    placeholder={SUBSCRIPTION.FORM.CURRENT_COMPANY.PLACEHOLDER}
                    label={currentCompanyField.label}
                    icon={<MdOutlineShareLocation size={16} />}
                    type="custom"
                    normalizeText={true}
                    defaultValue={currentCompanyField.defaultValue}
                    {...field}
                    onChange={currentCompanyField.onChange}
                    onBlur={currentCompanyField.onBlur}
                  />
                )}
              </FormField>
            </Col>
          </Row>
        </Form>
      </div>
    )
  );
};

export default BrokerageMandate;
